import { j as y } from "./jsx-runtime-3tyXYecC.mjs";
import { m as k } from "./tss-DN0acMKN.mjs";
import { I as B } from "./icon-v2-DGtVEk7e.mjs";
import { _ as U, u as V, a as C } from "./objectWithoutPropertiesLoose-Cg0fb85x.mjs";
import * as v from "react";
import { g as j, a as w, u as P, b as z, c as F, d as I } from "./useButton-BpXsRUgx.mjs";
function L(a) {
  return w("ButtonUnstyled", a);
}
j("ButtonUnstyled", ["root", "active", "disabled", "focusVisible"]);
const N = ["className", "component", "components", "componentsProps", "children", "disabled", "action", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseLeave"], W = (a) => {
  const {
    active: s,
    disabled: o,
    focusVisible: t
  } = a;
  return I({
    root: ["root", o && "disabled", t && "focusVisible", s && "active"]
  }, L, {});
}, _ = /* @__PURE__ */ v.forwardRef(function(s, o) {
  var t;
  const {
    className: e,
    component: n,
    components: g = {},
    componentsProps: l = {},
    children: c,
    action: f
  } = s, r = U(s, N), i = v.useRef(), u = V(i, o), {
    active: h,
    focusVisible: d,
    setFocusVisible: m,
    getRootProps: p
  } = P(C({}, s, {
    ref: u
  }));
  v.useImperativeHandle(f, () => ({
    focusVisible: () => {
      m(!0), i.current.focus();
    }
  }), [m]);
  const b = C({}, s, {
    active: h,
    focusVisible: d
  }), x = (t = n ?? g.Root) != null ? t : "button", $ = z(x, C({}, r, l.root), b), R = W(b);
  return /* @__PURE__ */ y.jsx(x, C({}, p(), $, {
    className: F(R.root, e, $.className),
    children: c
  }));
}), H = k()((a, s) => {
  var p;
  const { constructs: o, mixins: t, borderRadiuses: e, palette: n, transitions: g, typography: l } = a, { disabled: c, focused: f, size: r = "medium", status: i, variant: u = "form" } = s, h = {
    small: 30,
    medium: 38,
    large: 46
  }, d = (b) => h[b], m = {
    borderLeft: "1px solid transparent",
    borderRadius: u === "single" ? `${e[200]} ${e[1e3]} ${e[1e3]} ${e[200]}` : `${e[200]}`,
    boxShadow: `0 0 0 6px ${t.alpha(t.fieldStatusColor(i, n, o.border.primary.medium), 0.1)}`,
    color: t.fieldStatusColor(i, n, o.text.primary.strong),
    fill: o.icon.primary.strong,
    height: d(r),
    outline: `2px solid ${t.fieldStatusColor(i, n, o.border.primary.medium)}`
  };
  return {
    root: {
      alignItems: "center",
      display: "flex"
    },
    divider: {
      borderLeft: `1px solid ${o.border.neutral.weak}`,
      height: d(r) - 14
    },
    button: {
      alignItems: "center",
      backgroundColor: c ? o.surface.neutral.xxWeak : o.surface.neutral.forcedWhite,
      border: "unset",
      borderLeft: "1px solid transparent",
      borderRadius: u === "single" ? `${e[200]} ${e[1e3]} ${e[1e3]} ${e[200]}` : `0 ${e[200]} ${e[200]} 0`,
      color: o.text.neutral.weak,
      cursor: c ? "auto" : "pointer",
      display: "flex",
      fill: o.icon.neutral.medium,
      flex: "0 0 auto",
      fontFamily: l.fontFamily,
      fontSize: (p = l.xsmall) == null ? void 0 : p.fontSize,
      fontWeight: l.fontWeightSemibold,
      height: d(r),
      margin: 0,
      padding: "0 13px",
      transition: g.create("outline", { duration: 50 }),
      // hover state: only show if hovered and not also focused
      "&:hover:not(:focus):not(:focus-within):not(:focus-visible)": !f && !c ? {
        backgroundColor: o.surface.neutral.xWeak,
        borderLeft: "1px solid transparent",
        borderRadius: u === "single" ? `${e[200]} ${e[1e3]} ${e[1e3]} ${e[200]}` : e[200],
        fill: o.icon.neutral.medium,
        outline: `1px solid ${t.fieldStatusColor(i, n, o.border.neutral.medium)}`,
        // input is focused and this button is hovered
        ".Mui-focused &": {
          outlineColor: t.fieldStatusColor(i, n, o.border.primary.medium)
        }
      } : {},
      "&:focus, &:focus-within, &:focus-visible": m,
      // if the input has the "focus" prop set, add the focusVisible overrides
      ...f ? m : {}
    }
  };
});
function A(a) {
  const {
    ariaControls: s,
    ariaExpanded: o,
    ariaHaspopup: t,
    ariaLabel: e,
    biId: n,
    children: g,
    containerRef: l,
    dataMenuId: c,
    disabled: f = !1,
    icon: r,
    id: i,
    focused: u = !1,
    onBlur: h,
    onClick: d,
    onFocus: m,
    size: p = "medium",
    ...b
  } = a, { classes: x } = H(a), $ = (S) => ({
    teenie: 12,
    small: 12,
    medium: 16,
    large: 20,
    biggie: 20
  })[S] ?? 16, R = [b["data-fabric-component"], "PickerButton"].filter(Boolean).join(" ");
  return /* @__PURE__ */ y.jsxs("div", { className: x.root, "data-fabric-component": R, children: [
    /* @__PURE__ */ y.jsx("div", { className: x.divider }),
    /* @__PURE__ */ y.jsx(
      _,
      {
        "aria-controls": s,
        "aria-expanded": o,
        "aria-haspopup": t,
        "aria-label": e,
        className: x.button,
        "data-bi-id": n,
        "data-menu-id": c,
        disabled: f,
        focused: u,
        id: i,
        onBlur: h,
        onClick: d,
        onFocus: m,
        ref: l,
        children: g || r && /* @__PURE__ */ y.jsx(B, { name: r, size: $(p) }) || null
      }
    )
  ] });
}
export {
  A as P
};
//# sourceMappingURL=picker-button-Cfkqdcrg.mjs.map
